import { ClientError, ClientErrorWithResponse } from '~client/error/client-error';

/**
 * Represents an `ApiSauce` `CLIENT_ERROR` problem.
 */
export class ClientRequestError<T> extends ClientError implements ClientErrorWithResponse<T> {
  public statusCode: number;
  public response: T;

  constructor(statusCode: number, response: T) {
    super(`The client request failed with status code '${statusCode}'`);
    Object.setPrototypeOf(this, ClientRequestError.prototype);

    this.statusCode = statusCode;
    this.response = response;
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/error/client-request-error.ts